import { Route, Routes } from 'react-router-dom'
import { ToastProvider } from './context/ToastContext'
import HomePage from './pages/HomePage'
import ConsultationsPage from './pages/ConsultationsPage'
import AstrologerDetailsPage from './pages/AstrologerDetailsPage'
import BookingPage from './pages/BookingPage'
import MaharajDetailsPage from './pages/MaharajDetailsPage'
import MaharajBookingPage from './pages/MaharajBookingPage'
import MaharajGemstoneBookingPage from './pages/MaharajGemstoneBookingPage'
import BookingDetailsPage from './pages/BookingDetailsPage'
import AppointmentDetailsPage from './pages/AppointmentDetailsPage'
import VideoConsultationPage from './pages/VideoConsultationPage'
import LiveStreamPage from './pages/LiveStreamPage'
import FaqPage from './pages/FaqPage'
import GalleryPage from './pages/GalleryPage'
import GalleryAlbumPage from './pages/GalleryAlbumPage'
import ConsultationInviteModal from './components/sections/videoCall/ConsultationInviteModal'
import ScrollManager from './components/common/ScrollManager'

export default function App() {
  return (
    <ToastProvider>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/consultations" element={<ConsultationsPage />} />
        <Route path="/astrologers/:id" element={<AstrologerDetailsPage />} />
        <Route path="/astrologers/:id/book" element={<BookingPage />} />
        <Route path="/maharaj-ji" element={<MaharajDetailsPage />} />
        <Route path="/book-maharaj-ji" element={<MaharajBookingPage />} />
        <Route path="/book-maharaj-ji/gemstone" element={<MaharajGemstoneBookingPage />} />
        {/* Both detail routes render from the same /booking-by-id/:id read. */}
        <Route path="/bookings/:id" element={<BookingDetailsPage />} />
        <Route path="/astrologer/appointments/:id" element={<AppointmentDetailsPage />} />
        <Route path="/consultations/:id/video" element={<VideoConsultationPage />} />
        {/* One live session. Public - watching needs no account - and it
            doubles as the astrologer's own studio (the server answers their
            join with a publisher token). There is no listing page: live
            sessions surface as a band on the home pages (LiveNowSection),
            which is where people already are when one starts. */}
        <Route path="/live/:id" element={<LiveStreamPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/gallery/:id" element={<GalleryAlbumPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      {/* Rings anywhere in the app when the astrologer starts a video consultation. */}
      <ConsultationInviteModal />
    </ToastProvider>
  )
}
